import { Component, Inject } from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import {ShareState} from "../../elements/share-editor/share-editor.component";
import {US_SubHeader} from "../../api/models/us_sub-header";
import {MessageDialogComponent} from "../message-dialog/message-dialog.component";

export interface CopyInteractiveDialogData {
  userSubscriptions: US_SubHeader[];
  dialogTitle: string;
  name: string;
  shareState: ShareState;
  isOwner: boolean;
}

@Component({
  selector: "copy-interactive-dialog",
  templateUrl: "./copy-interactive-dialog.component.html",
})
export class CopyInteractiveDialogComponent {
  public Result: DialogResult;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CopyInteractiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CopyInteractiveDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    if (!this.data.name || this.data.name === '') {
     MessageDialogComponent.showDialog(this.dialog, "Validation Error", "Name Required").subscribe();
    } else {
      this.Result.ResultType = DialogResultType.Ok;
      this.Result.ResultData = this.data;
      this.dialogRef.close(this.Result);
    }
  }
}
